import React, { useEffect } from "react";
import { Box, Button, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextFields from "../../../Component/form/TextFields";
import PhoneNumberField from "../../../helper/Form/PhoneNumber";

const validationSchema = yup.object().shape({
  orgName: yup.string(),
  address1: yup.string(),
  address2: yup.string(),
  orgEmail: yup.string().email("Invalid email format"),
  orgPhone: yup.string(),
  state: yup.string(),
  city: yup.string(),
  zipCode: yup.string(),
});

export default function OrganizationDetails({
  handleNext,
  getValues,
  setGetValues,
  handleBack,
}) {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (getValues?.organization) {
      setValue("orgName", getValues?.organization?.orgName || "");
      setValue("address1", getValues?.organization?.address?.address1 || "");
      setValue("address2", getValues?.organization?.address?.address2 || "");
      setValue("orgEmail", getValues?.organization?.orgEmail || "");
      setValue("orgPhone", getValues?.organization?.orgPhone || "");
      setValue("state", getValues?.organization?.address?.state || "");
      setValue("city", getValues?.organization?.address?.city || "");
      setValue("zipCode", getValues?.organization?.address?.zipCode || "");
    }
  }, [getValues, setValue]);

  const onSubmit = (data) => {
    const payload = {
      orgName: data.orgName,
      orgPhone: data.orgPhone,
      orgEmail: data.orgEmail,
      address: {
        address1: data.address1,
        address2: data.address2,
        state: data.state,
        city: data.city,
        zipCode: data.zipCode,
      },
    };

    setGetValues((prevData) => ({
      ...prevData,
      organization: payload,
    }));

    handleNext();
  };

  return (
    <Box sx={{ mx: "auto", maxWidth: 800 }}>
      <Grid container spacing={2}>
        {/* Organization Name */}
        <Grid item xs={12} md={12}>
          <TextFields
            control={control}
            name="orgName"
            label="Organization Name"
            placeholder="Enter organization name"
            error={errors.orgName}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PhoneNumberField
            control={control}
            name="orgPhone"
            label="Organization Phone"
            error={errors.orgPhone}
          />
        </Grid>
        {/* Organization Email */}
        <Grid item xs={12} md={6}>
          <TextFields
            control={control}
            name="orgEmail"
            label="Organization Email"
            placeholder="Enter organization email"
            error={errors.orgEmail}
          />
        </Grid>

        {/* Address Line 1 */}
        <Grid item xs={12}>
          <TextFields
            control={control}
            name="address1"
            label="Address Line 1"
            placeholder="Enter address line 1"
            error={errors.address1}
          />
        </Grid>

        {/* Address Line 2 */}
        <Grid item xs={12}>
          <TextFields
            control={control}
            name="address2"
            label="Address Line 2"
            placeholder="Enter address line 2"
            error={errors.address2}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextFields
            control={control}
            name="state"
            label="State"
            placeholder="Enter state"
            error={errors.state}
          />
        </Grid>

        {/* City */}
        <Grid item xs={12} md={4}>
          <TextFields
            control={control}
            name="city"
            label="City"
            placeholder="Enter city"
            error={errors.city}
          />
        </Grid>

        {/* State */}

        {/* Zip Code */}
        <Grid item xs={12} md={4}>
          <TextFields
            control={control}
            name="zipCode"
            label="Zip Code"
            placeholder="Enter zip code"
            error={errors.zipCode}
          />
        </Grid>

        {/* Organization Phone */}
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleBack}
          sx={{ textTransform: "none" }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          sx={{ textTransform: "none" }}
          onClick={handleSubmit(onSubmit)}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}
